
import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import S3Image from '@/components/S3Image.vue';
import Loader from '@/components/Loader.vue';
import ChartCard from '@/components/material/ChartCard.vue';
import Chartist from 'chartist';
import {Auth} from 'aws-amplify';

function clickableChart(options) {
  return function clickableChartChild(chart) {
    if (chart instanceof Chartist.Bar) {
      chart.on('draw', (data) => {
        if (data.type === 'bar') {
          data.element._node.onclick = () => {
            window.location.href = data.meta;
          };
        }

        if (data.text === 'Akzeptiert') {
          data.element._node.onclick = () => {
            window.location.href = `/#/admin/events/${options.eventId}?type=70#guestCard`;
          };
        }

        if (data.text === 'Abgelehnt') {
          data.element._node.onclick = () => {
            window.location.href = `/#/admin/events/${options.eventId}?type=99#guestCard`;
          };
        }

        if (data.text === 'Ausstehend') {
          data.element._node.onclick = () => {
            window.location.href = `/#/admin/events/${options.eventId}?type=0#guestCard`;
          };
        }
      });
    }
  };
}

@Component({
  components: {
    ChartCard,
    Loader,
    S3Image,
  },
})
export default class VDashboard extends Vue {
  private loading: boolean = false;

  @Action('admin/events/read') private readEvents!: any;
  @Action('admin/trainings/read') private readTrainings!: any;
  @Getter('admin/events/dashboard') private events!: any;
  @Getter('admin/trainings/dashboard') private trainings!: any;

  private pieOptions: any = {};
  private eventHandler: any = [
    {
      event: 'draw',
      fn(data) {
        if (data.type === 'bar') {
          data.element._node.onclick = () => {
            window.location = data.meta;
          };
        }
      },
    },
  ];

  private getChartOptions: any = (event: any) => {
    return {
      axisY: {
        onlyInteger: true,
      },
      plugins: [
        clickableChart({
         eventId: event.id,
       }),
      ],
    };
  }

  private async isJulia() {
    const user = await Auth.currentAuthenticatedUser();
    return user.username === 'jkoenig';
  }

  private async created() {
    this.readEvents();
    const isJulia = await this.isJulia();
    if (!isJulia) {
      this.readTrainings();
    }
  }

  private getData(event) {
    return {
      labels: ['Akzeptiert', 'Abgelehnt', 'Ausstehend'],
      series: [
        [
          {
            value: (event.guests[70] + (event.guests.companions ? event.guests.companions : 0)),
            meta: `#/admin/events/${event.id}?type=70#guestCard`,
          },
          {
            value: (event.guests[99] ? event.guests[99] : 0),
            meta: `#/admin/events/${event.id}?type=99#guestCard`,
          },
          {
            value: (event.guests[0] ? event.guests[0] : 0),
            meta: `#/admin/events/${event.id}?type=0#guestCard`,
          },
        ],
      ],
    };
  }

  private getPieData(event) {
    return {
      labels: ['Offen', 'Vergeben'],
      series: [event.capacity - event.guests, event.guests],
    };
  }

  private daysLeft(training) {
    const eventDate = new Date(training.date);
    const today = new Date();

    return ((eventDate.getTime() - today.getTime()) / (1000 * 3600 * 24)).toFixed();
  }

  private openEvent(event) {
    this.$router.push({name: 'AdminEvent', params: {id: event.id}});
  }

  private openTraining(training) {
    this.$router.push({name: 'AdminTraining', params: {id: training.id}});

  }
}
